import React from 'react';
import { useRecoilValue } from 'recoil';
import { CardBody } from '../../components/CardBody';
import { CardHeader } from '../../components/CardHeader';
import { CardTitle } from '../../components/CardTitle';

import { allProductsState } from '../../recoil/atoms';
import { assetPathFn } from '../../util';
import { ShopNowCardFooter, ShopNowCardSection } from '../HomeLander/HomeLanderMobile';
import { HeroCallout } from '../HeroCallout';
import { WistiaPanel } from '../../components/WistiaPanel';
import { NewsIcons } from '../../product_detail/components/NewsIcons';
import { ShopAllColors } from '../components/ShopAllColors';
import { ProductFeatures } from '../components/ProductFeatures';
import { LanderTopHero } from '../components/LanderTopHero';
import { ProductHandle } from '../../enums/ProductHandle.enum';
import { CardFooter } from '../../components/CardFooter';
import styles from './LiftWearCamiLanderMobile.module.scss';
import { useLanderControls } from '../LanderContext';

export const LiftWearCamiLanderMobile: React.FC = () => {
  const allProducts = useRecoilValue(allProductsState);
  const { scrollToProductSection } = useLanderControls();

  const wistiaVideoId = 'txjj1yry1r';
  const padding = { padding: '145.0% 0 0 0' };

  return (
    <>
      <CardBody>
        <LanderTopHero heroImage={'mobile-liftwear-cami-lander-top-hero-1.jpg'} title={'LiftWear Cami'} subTitle={`Meet the world's smartest Cami.`}>
          <HeroCallout
            orderIndex={0}
            label={
              <>
                Adjustable
                <br /> straps
              </>
            }
            labelColor={'black'}
            titleStyles={{ fontSize: 12 }}
            inlineStyles={{
              mobile: {
                right: `8%`,
                top: `18.5%`,
                flexDirection: 'row-reverse',
              },
            }}
          />
          <HeroCallout
            orderIndex={1}
            label="Waist-free lift"
            labelColor={'black'}
            titleStyles={{ fontSize: 12 }}
            inlineStyles={{
              mobile: {
                right: `5.5%`,
                top: `49.8%`,
                flexDirection: 'row-reverse',
              },
            }}
          />
          <HeroCallout
            orderIndex={2}
            label={
              <>
                Targeted
                <br /> Smoothing
              </>
            }
            titleStyles={{ lineHeight: '22px', fontSize: 12 }}
            inlineStyles={{
              mobile: {
                left: `49%`,
                top: `62%`,
                flexDirection: 'row-reverse',
              },
            }}
          />
        </LanderTopHero>
      </CardBody>
      <ShopNowCardFooter onClick={scrollToProductSection} />
      <CardHeader />
      <CardBody>
        <NewsIcons />
        <ProductFeatures
          features={[
            {
              imgName: 'feature-lwc-desktop-1.jpg',
              title: 'Underwire-free lift',
              description: 'A bonded cradle and molded removable cups lift your chest for support and comfort.',
            },
            {
              imgName: 'feature-lwc-desktop-2.jpg',
              title: 'Targeted smoothing',
              description: 'Targeted X-shaped panel on the interior hugs your midsection for extra waist shaping.',
            },
            {
              imgName: 'feature-lwc-desktop-3.jpg',
              title: 'Adjustable straps',
              description: 'Adjust the length of your straps, or cross them in the back from extra support.',
            },
          ]}
        />
        <CardTitle text="The perfect layering piece for a smoother fit" style={{ paddingTop: 0 }} type="capital" />
        <div className={styles.comparison}>
          <img src={assetPathFn('liftwear-short-before-after.jpg')} alt="comparison" />
          <div>
            <div>competitor</div>
            <div>Liftwear</div>
          </div>
        </div>
        <ShopNowCardSection onClick={scrollToProductSection} />
        <WistiaPanel videoId={wistiaVideoId} responsivePadding={padding} />
        <ShopAllColors product={allProducts[ProductHandle.LiftWearCami]} />
      </CardBody>
      <CardFooter />
    </>
  );
};

export default LiftWearCamiLanderMobile;
